<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- in faculty tt {{uid}} {{org}} {{ay}} -->
        <v-card :loading="tt_load" class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Time Table
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-card v-if="final_tt_list!=null">
                <v-row justify="center" dense>
                    <caption>
                        {{faculty}}:{{faculty_name}}
                    </caption>
                </v-row>
                <v-col cols="12" sm="12" md="12" v-for="(ftt,index) in final_tt_list" :key="index">
                    <v-row justify="center" dense> <strong> Stream :: </strong> {{ftt.stream}} </v-row>
                    <v-simple-table class="elevation-1 mytable" dense>
                        <thead>
                            <tr>
                                <th style="background-color: #ffd699;">AY:{{dis_ay.ay}}</th>
                                <th class="toolbar" v-for="(s,index) in ftt.slot" :key="index">{{s.start_time}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(tt,index) in ftt.tt_list" :key="index">
                                <th width="10%" class="toolbar">
                                    <center>{{tt[0].tt_day}}</center>
                                </th>
                                <td v-for="(data,index) in tt" :key="index">
                                    <v-btn
                                        v-if="data.toshowcompulsory == true"
                                        class="btn-grad"
                                        width="100%"
                                        small
                                        :color="data.tt_slot_color"
                                        :title="`Subject:${data.tt_course_tip} Std:${data.tt_std} Div:${data.tt_div} Room:${data.tt_room} Event:${data.tt_event_tip}`"
                                    >
                                        <span v-if="data.tt_course!=null">
                                            <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                            {{data.tt_course}}
                                        </span>
                                        <a :href="data.tt_web_link" v-if="data.tt_web_link" target="_blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon color="white" v-bind="attrs" v-on="on" size="25">mdi mdi-link</v-icon>
                                                </template>
                                                <span>
                                                    Webinar Link!!!
                                                </span>
                                            </v-tooltip>
                                        </a>
                                        <span v-if="data.tt_room!=null">
                                            <v-icon color="blue" small>mdi-warehouse</v-icon>
                                            {{data.tt_room}}
                                        </span>
                                        <span v-if="data.tt_event!=null">
                                            <v-icon color="green" small>mdi-cricket</v-icon>
                                            {{data.tt_event}}
                                        </span>
                                        <span v-if="data.tt_div!=null">
                                            <v-icon color="#9808EB" small>mdi-standard-definition</v-icon>
                                            {{data.tt_std}}-{{data.tt_div}}
                                        </span>
                                    </v-btn>
                                    <span v-if="data.electives.length != 0">
                                        <v-tooltip right color="#00DBDE" dark>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    width="100%"
                                                    :id="data.tt_id"
                                                    v-for="(ele, index) in data.electives"
                                                    :key="index"
                                                    small
                                                    class="pt-2 mt-2 btn1-grad"
                                                    :title="`Subject:${ele.ele_crs} Room:${ele.ele_room} Event:${ele.ele_event} Instructor:${ele.ele_instructor}`"
                                                >
                                                    <span v-if="ele.ele_crs != null">
                                                        <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                        {{ ele.ele_crs }}
                                                    </span>
                                                    <a :href="ele.ele_link" v-if="ele.ele_link" target="_blank">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon color="white" v-bind="attrs" v-on="on" size="20">mdi mdi-link</v-icon>
                                                            </template>
                                                            <span>
                                                                Webinar Link!!!
                                                            </span>
                                                        </v-tooltip>
                                                    </a>
                                                    <span v-if="ele.ele_room != null">
                                                        <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                        {{ ele.ele_room }}
                                                    </span>
                                                    <span v-if="ele.ele_event != null">
                                                        <v-icon color="green" small>mdi-cricket</v-icon>
                                                        {{ ele.ele_event }}
                                                    </span>
                                                    <span v-if="ele.ele_instructor != '--'">
                                                        <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                        {{ ele.ele_instructor }}
                                                    </span>
                                                </v-btn>
                                            </template>
                                            <span>
                                                Elective Time Table
                                            </span>
                                        </v-tooltip>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            uid: String,
            ay: String,
            org: Number,
        },
        data() {
            return {
                final_tt_list: null,
                tt_list: null,
                slots: null,
                slot_type: null,
                faculty: null,
                tt_load: false,
                dis_ay: null,
                faculty_name: "",
                dialog: false,
                web_Link: null,
                tt_id: null,
                snackbar_msg: "",
                color: "",
                snackbar: false,
            };
        },
        watch: {
            uid() {
                this.getData();
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getData() {
                 this.tt_load = true;
                const formData = {
                    uid: this.uid,
                    ay: this.ay,
                    //stream:this.stream,
                    org: this.org,
                };
                axios
                    .post("/Management/getFacultyTT", formData)
                    .then((res) => {
                       // console.log(res.data);
                        if (res.data.flag == "YES") {
                            this.tt_list = res.data.tt_list;
                            console.log(this.tt_list);
                            this.slots = res.data.slot;
                            this.slot_type = res.data.slot_type;
                            this.faculty = res.data.faculty;
                            this.dis_ay = res.data.ay;
                            this.final_tt_list = res.data.final_tt_list;
                            this.faculty_name = res.data.faculty_name;
                        } 
                        // else {
                        //     alert(res.data.status_reason);
                        // }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //stop loader
                        this.tt_load = false;
                    });
            },
        },
    };
</script>
<style scoped>
    /* table {
        border-collapse: collapse;
        font-size: 12px;
        border: 2px solid #cccccc;
        background-color: #ffffff;
    }
    th {
        border: 2px solid #cccccc;
        padding: 4px;
    }
    td:nth-child(odd) {
        width: 15em;
        padding: 4px;
        text-align: center;
        border: 2px solid #cccccc;
    }
    td:nth-child(even) {
        width: 15em;
        padding: 4px;
        text-align: center;
        border: 2px solid #cccccc;
    } */
    a:link {
        text-decoration: none !important;
    }
    td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-grad {
        /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
    }
    .btn-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: black;
        box-shadow: 0 0 20px rgb(190, 187, 187);
        border-radius: 10px;
        display: block;
    }

    .btn-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: black;
        text-decoration: none;
    }
    .btn1-grad {
        background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
    }
    .btn1-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        border-radius: 10px;
        display: block;
    }

    .btn1-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
</style>
